import { jsx as l } from "react/jsx-runtime";
function r({ children: t, className: e = "" }) {
  return /* @__PURE__ */ l("div", { className: `tw-h-full tw-w-full tw-px-2 tw-py-4 ${e}`, children: t });
}
r.displayName = "CarouselItem";
export {
  r as CarouselItem
};
